"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkBrowser = checkBrowser;
var _StudioLogger = require("@studio/logger/StudioLogger");
var _ReadinessCheck = require("@studio/constants/ReadinessCheck");
var LOG = new _StudioLogger.StudioLogger('checkBrowser');
function checkBrowser() {
  var userAgent = navigator.userAgent;
  var isChromium = userAgent.includes('Chrome') || userAgent.includes('Chromium') || userAgent.includes('Edg');
  var message = '';
  if (!isChromium) {
    message = 'Unsupported browser';
    LOG.warn("ReadinessCheck - ".concat(message, ":"), userAgent);
  }
  return {
    status: isChromium ? _ReadinessCheck.PASSED : _ReadinessCheck.FAILED,
    data: message
  };
}